import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "./page/homepage/homepage";
import Viewer from "./layout/Viewer";
import PageNotFound from "./page/404/PageNotFound";
import Detail from "./page/detail/detail";
import CourseList from "./page/course/courseList";
import Checkout from "./page/checkout/checkout";
import HelpUs from "./page/help/help";
import DemoPage from "./page/demo/demoPage";
import LeadLogin from "./leads/pages/login/login";
import LeadPanel from "./leads/pages/leadPanel";
import LeadList from "./leads/components/leads/leadList";
import LeadEdit from "./leads/components/leads/leadEdit";
import Users from "./leads/components/users/users";
import UserEdit from "./leads/components/users/userEdit";
import UserSettings from "./leads/components/users/settings";
import LeadSettings from "./leads/components/leads/leadSettings";
import AddLead from "./leads/components/leads/addLead";
import UserAdd from "./leads/components/users/userAdd";
import About from "./page/about/about";
import Followups from "./leads/components/leads/followups";
import Examination from "./examination/examination";
import { Registration, Login, Home, Landing, TestPage } from "./examination/pages";
import ProtectedRoute from "./auth/ProtectedRoute";
import Exam from "./leads/components/exam/examination";
import ExamEditPage from "./leads/components/exam/examEdit";
import NewExam from "./leads/components/exam/newExam";

function App() {
  return (
    <Routes>
      <Route element={<Viewer />}>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/all-courses" element={<CourseList />} />
        <Route path="/course/details/:id" element={<Detail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/help" element={<HelpUs />} />
        <Route path="/book-demo" element={<DemoPage />} />
        <Route path="/about" element={<About />} />
        {/* TEST ROUTE */}
        <Route path="test/register/:test_id" element={<Registration />} />
        <Route path="login" element={<Login />} />
        {/* 404 */}
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route path="/internal/lead/login" element={<LeadLogin />} />
      <Route element={<LeadPanel />}>
        <Route path="/home/lead-list" element={<LeadList />} />
        <Route path="/home/add-lead" element={<AddLead />} />
        <Route path="/home/lead-edit/:lead_id" element={<LeadEdit />} />
        <Route path="/home/lead-settings" element={<LeadSettings />} />
        <Route path="/home/users" element={<Users />} />
        <Route path="/home/followups" element={<Followups />} />
        <Route path="/home/add-user" element={<UserAdd />} />
        <Route path="/home/user-edit/:user_id" element={<UserEdit />} />
        <Route path="/home/user-settings" element={<UserSettings />} />
        <Route path="/home/exam" element={<Exam />} />
        <Route path="/home/create/exam" element={<NewExam />}/>
        <Route path="/home/exam-edit/:test_id" element={<ExamEditPage />} />
      </Route>
      <Route
        element={
          <ProtectedRoute>
            <Examination />
          </ProtectedRoute>
        }
      >
        <Route path="examination/landing" element={<Landing />} />
        <Route path="examination/home/exam/start/:test_id" element={<Home />} />
        <Route path="examination/home/exam/test/:test_id" element={<TestPage />}/>
      </Route>
    </Routes>
  );
}

export default App;
